import React from 'react';
import PropTypes from 'prop-types';
import { Slider as MuiSlider, Box } from '@material-ui/core';

import useStyles from './useStyles';

const Slider = props => {
  const classes = useStyles();
  const { min, marks, className, ...rest } = props;

  const sliderClasses = {
    root: classes.root,
    thumb: classes.thumb,
    active: classes.active,
    track: classes.track,
    rail: classes.rail,
    mark: classes.mark,
    markLabel: classes.markLabel,
  };

  return (
    <Box width="100%" height={50} display="flex" alignItems="flex-end" className={className}>
      <MuiSlider {...rest} min={min} marks={marks} classes={sliderClasses} />
    </Box>
  );
};

Slider.propTypes = {
  className: PropTypes.string,
  max: PropTypes.number.isRequired,
  min: PropTypes.number,
  marks: PropTypes.arrayOf(PropTypes.shape()),
};

Slider.defaultProps = {
  className: '',
  min: 0,
  marks: [],
};

export default Slider;



// WEBPACK FOOTER //
// ./src/sharedComponents/Slider/Slider.js